import { Tooltip, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

/**
 * Gateway ichidagi qurilma o'rni (`devIndex`) — SERVER topadi, operator
 * kiritmaydi.
 *
 * <h2>⚠️ BO'SH QIYMAT — XATO EMAS</h2>
 * Bu komponentning butun ma'nosi shunda. `null` ikki holatda bo'ladi va
 * ikkalasi ham NORMAL: qurilma hali gateway'ga birinchi marta ulanmagan,
 * yoki gateway hali javob bermagan. Server keyingi urinishda uni o'zi
 * topadi va keshlaydi.
 *
 * Uni bo'sh katak qilib chizish IKKI xil yolg'on beradi: "ma'lumot
 * yuklanmadi" va "bu yerda to'ldirilishi kerak bo'lgan maydon bor". Aynan
 * shu sababdan matn yozilgan va u "hali" so'zi bilan boshlanadi — ya'ni
 * kutilayotgan holat, nosozlik emas (`attendance.lastSeenNever` bilan bir
 * xil qoida).
 *
 * ⚠️ FAQAT `ISUP_GATEWAY` qurilmasida chaqiriladi. `DIRECT_ISAPI` da bu
 * tushuncha umuman mavjud emas va uni "—" bilan ko'rsatish "bu yerda ham
 * bo'lishi kerak edi" degan taassurot berardi.
 */
export function DeviceGatewayIndex({ devIndex }: { devIndex: string | null }) {
  const { t } = useTranslation()

  if (devIndex === null) {
    return (
      <Tooltip title={t('attendance.gatewayDevIndexPendingHint')}>
        <Typography.Text type="secondary">
          {t('attendance.gatewayDevIndexPending')}
        </Typography.Text>
      </Tooltip>
    )
  }
  return (
    <Typography.Text code copyable={{ text: devIndex }}>
      {devIndex}
    </Typography.Text>
  )
}
